import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TableCollapseService {
  groupSelectedMemberId: number;
  notificationSelectedCollarId: number;
  movebankForwarderSelectedCollarId: number;
  dataForwarderSelectedCollarId: number;
  memberSelectedGroupId: number;
  commandContentId: string;

  onSelectionChanged$ = new BehaviorSubject<number | string>(undefined);

  isGroupSelectedMemberId(memberId: number) {
    return memberId === this.groupSelectedMemberId;
  }
  isNotificationSelectedCollarId(collarId: number) {
    return collarId === this.notificationSelectedCollarId;
  }
  isMovebankForwarderSelectedCollarId(collarId: number) {
    return collarId === this.movebankForwarderSelectedCollarId;
  }
  isDataForwarderSelectedCollarId(collarId: number) {
    return collarId === this.dataForwarderSelectedCollarId;
  }
  isMemberSelectedGroupId(groupId: number) {
    return groupId === this.memberSelectedGroupId;
  }
  isCommandContentIdSelected(commandId: string) {
    return commandId === this.commandContentId;
  }

  setGroupSelectedMemberId(memberId: number) {
    this.groupSelectedMemberId = memberId;
    this.onSelectionChanged$.next(memberId);
  }
  setNotificationSelectedCollarId(collarId: number) {
    this.notificationSelectedCollarId = collarId;
    this.onSelectionChanged$.next(collarId);
  }
  setMovebankForwarerSelectedCollarId(collarId: number) {
    this.movebankForwarderSelectedCollarId = collarId;
    this.onSelectionChanged$.next(collarId);
  }
  setDataForwarerSelectedCollarId(collarId: number) {
    this.dataForwarderSelectedCollarId = collarId;
    this.onSelectionChanged$.next(collarId);
  }
  setMemberSelectedGroupId(groupId: number) {
    this.memberSelectedGroupId = groupId;
    this.onSelectionChanged$.next(groupId);
  }
  setCommandContentIdSelected(commandId: string) {
    this.commandContentId = commandId;
    this.onSelectionChanged$.next(commandId);
  }
}
